import { setSettingsRestored } from "store/auth/authSlice";
import { restorePersistedState } from "./restoreActions";
import { loginUser, refreshToken } from "store/auth/authActions";

const getPersistedState = (state, persistenceConfig) =>
  Object.fromEntries(
    Object.entries(persistenceConfig)
      .map(([sliceName, config]) => {
        const sliceState = state[sliceName];

        if (!sliceState || !config.fields?.length) {
          return [sliceName, null];
        }

        const fields = Object.fromEntries(
          config.fields
            .filter((field) => field in sliceState)
            .map((field) => [field, sliceState[field]])
        );

        return [sliceName, fields];
      })
      .filter(([, fields]) => fields !== null)
  );

// Middleware для автоматического сохранения.
export const createPersistenceMiddleware = (tenant, persistenceConfig) =>
  (store) => {
    let currentStorageKey = null;
    let lastSerialized = null;

    return (next) => (action) => {
      const result = next(action);
      const state = store.getState();
      const userId = state.auth.userInfo?.userId;

      if (!tenant || userId == null || userId === '') {
        currentStorageKey = null;
        lastSerialized = null;
        return result;
      }

      const storageKey = `${tenant}:${userId}`;

      // При смене пользователя не сохраняем его состояние немедленно.
      if (storageKey !== currentStorageKey) {
        currentStorageKey = storageKey;
        lastSerialized = null;
      }

      // Ждём, пока настройки текущего пользователя будут восстановлены.
      if (!state.auth.settingsRestored) {
        lastSerialized = null;
        return result;
      }

      const serialized = JSON.stringify(
        getPersistedState(state, persistenceConfig)
      );

      // Не записываем данные, если сохраняемые поля не изменились.
      if (serialized !== lastSerialized) {
        try {
          localStorage.setItem(storageKey, serialized);
          lastSerialized = serialized;
        } catch (error) {
          console.error('Failed to persist settings:', error);
        }
      }

      return result;
    };
  };

export const restoreUserSettings = (tenant, userId) =>
  (dispatch, getState) => {
    const storageKey = `${tenant}:${userId}`;

    let persistedState = {};

    try {
      const serialized = localStorage.getItem(storageKey);

      if(serialized) {
        const parsed = JSON.parse(serialized);

        if(
          parsed &&
          typeof parsed === 'object' &&
          !Array.isArray(parsed)
        ) {
          persistedState = parsed;
        }
        
      }

    } 
    catch (error) {
      console.error('Failed to restore settings:', error);
    }

    dispatch(restorePersistedState(persistedState));
    dispatch(setSettingsRestored(true));
  };